module.exports = __webpack_public_path__ + "img/gift.55d76957.svg";